import { FC, useState } from 'react';
import { Modal } from '../../../../components/modal/modal';
import TermsAcceptanceModalContent from './terms-acceptance-modal-content';
import './terms-acceptance-modal.scss';

export interface ITermsAcceptanceModalProps {
    termsContent: string;
    onAccept: () => Promise<void>;
}

const TermsAcceptanceModal: FC<ITermsAcceptanceModalProps> = ({
    termsContent,
    onAccept,
}) => {
    const [isChecked, setIsChecked] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleAccept = async () => {
        if (!isChecked || isSubmitting) {
            return;
        }

        setIsSubmitting(true);
        try {
            await onAccept();
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal isCloseDisabled>
            <TermsAcceptanceModalContent
                termsContent={termsContent}
                isChecked={isChecked}
                isSubmitting={isSubmitting}
                onCheckedChange={setIsChecked}
                onAcceptClick={handleAccept}
            />
        </Modal>
    );
};

export default TermsAcceptanceModal;
